import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import ProfileCard from "./components/profileCard";
import CustomTab, {
  TabContainer,
} from "../../../../components/tabs/customTabs";
import BasicCard from "./components/basicCard";
import useCommonFetch from "../../../../../hooks/useCommonFetch";
import { getStockDetail } from "../../../../../services/workspace/inventory.service";
import AssignedItemsHistoryCard from "./components/assignedItemsHistoryCard";
import AdvanceFilter from "../../../../components/filter/advanceFilter";
import ItemsCard from "./components/itemsCard";

const items = [
  { label: "Stock", path: "/inventory/stock" },
  { label: "Stock Detail", path: "" },
];

const StockDetail = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const [filters, setFilters] = useState({
    name: "",
    status: "",
  });

  const {
    loading,
    data: stockData,
    fetchData,
  } = useCommonFetch(getStockDetail, {
    id: id,
    dataPath: "stock",
    errorMessage: "Failed to fetch user detail!",
    customParams: {
      // additional_info: true,
      with: "category",
    },
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = Number(params.get("tab"));
    if (!isNaN(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  // ✅ when user clicks tab
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const heandleFetchData = () => {
    fetchData(
      {
        // additional_info: true,
        with: "category",
      },
      true,
      id
    );
  };

  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: (
        <BasicCard
          fetchData={fetchData}
          stockData={stockData}
          loading={loading}
          heandleFetchData={heandleFetchData}
        />
      ),
    },
    {
      id: "tab2",
      label: "Items",
      content: (
        <ItemsCard
          id={id}
          fetchData={fetchData}
          loading={loading}
          heandleFetchData={heandleFetchData}
          filters={filters}
        />
      ),
    },
    {
      id: "tab2",
      label: "Stock History",
      content: (
        <AssignedItemsHistoryCard
          id={id}
          fetchData={fetchData}
          loading={loading}
          heandleFetchData={heandleFetchData}
        />
      ),
    },
  ];

  // Apply filters
  const handleFilterChange = () => {
    // 👉 Call API with filters
  };

  // Clear filters
  const handleClearFilters = () => {
    setFilters({ name: "", status: "" });
    // 👉 Call API without filters
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={items} />
      <ProfileCard staffData={stockData} />
      <div className="flex flex-col gap-2 ">
        <div className="flex flex-row items-center justify-between">
          <CustomTab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          {activeTab === 1 && (
            <AdvanceFilter
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
              filterModule="stock"
              boxWidth="w-96" //
            >
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  Status
                </label>
                <select
                  className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  value={filters.name}
                  onChange={(e) =>
                    setFilters({ ...filters, name: e.target.value })
                  }
                >
                  <option value="">All</option>
                  <option value="0">Assigned</option>
                  <option value="1">Notassigned</option>
                  <option value="2">Damaged</option>
                  <option value="3">Expired</option>
                </select>
              </div>
            </AdvanceFilter>
          )}
        </div>
        <div className="max-h-[calc(100vh-39vh)] h-[calc(100vh-39vh)] overflow-y-auto scrollbar-hidden ">
          <TabContainer tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default StockDetail;
